import throttle from 'lodash/throttle';

export const activateElInViewport = (el, activeAttr) => {
  function setAttr() {
    if (isElInViewport(el)) {
      el.setAttribute(activeAttr, 'true');
      removeEventListeners();
    }
  }

  const listenerWithThrottle = throttle(setAttr, 50);

  function addEventListeners() {
    window.addEventListener('resize', listenerWithThrottle);
    window.addEventListener('scroll', listenerWithThrottle);
  }

  function removeEventListeners() {
    window.removeEventListener('resize', listenerWithThrottle);
    window.removeEventListener('scroll', listenerWithThrottle);
  }

  addEventListeners();
};

function isElInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
